<script>
  // TODO: clean up pagination
  import { createEventDispatcher } from 'svelte';
  import { loadingStore } from '../../stores/General';
  import PageSizerPicker from './PageSizerPicker.svelte';
  const dispatch = createEventDispatcher();

  export let count;
  export let page = 1;
  export let pageSize;

  $: pageCount = Math.ceil(count / pageSize);

  function handlePageChange(page) {
    const newPage = parseInt(page);
    if (newPage > 0 && newPage <= pageCount) {
      const detail = {
        page: newPage,
        pageSize,
      };
      dispatch('pageChange', detail);
    }
  }

  const paginatorPageClass = 'mx-2 text-xs';
  const paginatorActivePageClass = 'bg-custom-orange py-2 px-3 text-white rounded-2xl text-xs';
</script>

<div class="flex justify-center sm:justify-end items-center">
  <div class="w-24 mr-12">
    <PageSizerPicker on:pageChange pagination={{ count, page, pageSize }} />
  </div>

  <button
    disabled={page === 1 || $loadingStore.loading}
    on:click={() => handlePageChange(page - 1)}
    class="mr-2 sm:mr-2 rounded border border-transparent focus:outline-none focus:border-gray-800 text-gray-600 focus:shadow-outline-gray disabled:opacity-50"
    aria-label="Previous Page"
    role="link"
  >
    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.31348 10.0988L3.15676 6.94212L6.31348 3.7854"
        stroke="#F78907"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.99658 10.0988L6.83987 6.94212L9.99658 3.7854"
        stroke="#F78907"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </button>
  <div class="bg-custom-light-orange rounded-2xl text-xs py-2 pr-2" class:pl-2={page !== 1}>
    {#if pageCount <= 7}
      {#each Array.from({ length: pageCount }, (v, k) => k + 1) as paginatorPage}
        <button
          disabled={$loadingStore.loading}
          class="border-none"
          on:click={() => handlePageChange(paginatorPage)}
        >
          <span class={page == paginatorPage ? paginatorActivePageClass : paginatorPageClass}>
            {paginatorPage}
          </span>
        </button>
      {/each}
    {:else}
      {#each page > 3 && page < pageCount - 2 ? [1] : [1, 2, 3] as paginatorPage}
        <button
          disabled={$loadingStore.loading}
          class="border-none"
          on:click={() => handlePageChange(paginatorPage)}
        >
          <span class={page == paginatorPage ? paginatorActivePageClass : paginatorPageClass}>
            {paginatorPage}
          </span>
        </button>
      {/each}
      {#if page - 3 > 0}
        <button disabled class="border-none">
          <span class={paginatorPageClass}> ... </span>
        </button>
      {/if}
      {#if page - 3 > 0 && page < pageCount - 2}
        {#each Array.from({ length: 3 }, (v, k) => k + page - 1) as paginatorPage}
          <button
            disabled={$loadingStore.loading}
            class="border-none"
            on:click={() => handlePageChange(paginatorPage)}
          >
            <span class={page == paginatorPage ? paginatorActivePageClass : paginatorPageClass}>
              {paginatorPage}
            </span>
          </button>
        {/each}
      {/if}
      {#if page < pageCount - 2}
        <button disabled class="border-none">
          <span class={paginatorPageClass}> ... </span>
        </button>
      {/if}
      {#each page > 3 && page < pageCount - 2 ? [pageCount] : [pageCount - 2, pageCount - 1, pageCount] as paginatorPage}
        <button
          disabled={$loadingStore.loading}
          class="border-none"
          on:click={() => handlePageChange(paginatorPage)}
        >
          <span class={page == paginatorPage ? paginatorActivePageClass : paginatorPageClass}>
            {paginatorPage}
          </span>
        </button>
      {/each}
    {/if}
  </div>
  <button
    disabled={page === pageCount || $loadingStore.loading}
    on:click={() => handlePageChange(page + 1)}
    class="mx-2 sm:mx-2 rounded border border-transparent focus:outline-none focus:border-gray-800 text-gray-600 focus:shadow-outline-gray disabled:opacity-50"
    aria-label="Next Page"
    role="link"
  >
    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.31348 10.0988L9.47019 6.94212L6.31348 3.7854"
        stroke="#F78907"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.63062 10.0988L5.78733 6.94212L2.63062 3.7854"
        stroke="#F78907"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </button>
</div>
